export default class Constants {
    static get defaultNamespace() {
        return "grimoirejs";
    }
    static get x_gr_id() {
        return "x-gr-id";
    }
}



// WEBPACK FOOTER //
// ./src/Base/Constants.ts